import React, { useContext } from 'react';
import { type ILayerProps } from '@/version-types';
import { TextLayerContext } from '../context';
import { GlowUse, ShadowUse, StrokeUse } from '../uses';

type Props = {
    /**
     * 图层数据
     */
    layer: ILayerProps;
    /**
     * svg 文本元素
     */
    textElements: JSX.Element[];
};

export const VerticalGradientDisplay: React.FC<Props> = ({ layer, textElements }) => {
    const { defIDSuffix } = useContext(TextLayerContext)!;

    const { id, width, height } = layer;
    const groupId = `text-${id}`;

    return (
        <React.Fragment>
            <defs>
                <g id={groupId}>{textElements}</g>
            </defs>

            <GlowUse href={`#${groupId}`} layer={layer} />
            <ShadowUse href={`#${groupId}`} layer={layer} />
            <StrokeUse href={`#${groupId}`} layer={layer} />

            {textElements.map((item, idx) => {
                const fill = `url(#gradient-${id}-${defIDSuffix})`;
                const clipPathId = `clip-${id}-${idx}-${defIDSuffix}`;

                return (
                    <React.Fragment key={`vertical-gradient-display-${id}-${idx}`}>
                        <defs>
                            <clipPath id={clipPathId}>{item}</clipPath>
                        </defs>

                        <rect x={0} y={0} width={width} height={height} fill={fill} clipPath={`url(#${clipPathId})`} />
                    </React.Fragment>
                );
            })}
        </React.Fragment>
    );
};
